import { createSlice } from '@reduxjs/toolkit';

export interface storeAuction {
  [key: number]: any;
}

const auctionsSlice = createSlice({
  name: 'auctions',
  initialState: {} as storeAuction,
  reducers: {
    updateAuction(state, { payload }) {
      if (!state[payload.id]) {
        state[payload.id] = payload;
        return;
      }
      if (state[payload.id].amount > payload.amount) {
        return;
      }
      state[payload.id] = payload;
    },
  },
});

export const { updateAuction } = auctionsSlice.actions;
export default auctionsSlice.reducer;
